import { css } from '@emotion/react'
import colors from '@mathflat/common/style/colors'

const S = {
  multipleSelectContents: css`
    display: flex;
    border-radius: var(--Radius-100);
    max-height: 267px;
    padding: 0 4px;
    border: 1px solid ${colors.gray.$400};
    background-color: white;
  `,
  multipleSelectList: css`
    margin-left: 4px;
    flex: 1;
    overflow: auto;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    :first-of-type {
      margin-left: 0;
    }

    ::-webkit-scrollbar {
      display: none;
    }
  `,
  multipleSelectItem: css`
    :first-of-type {
      margin-top: 4px;
    }
    :last-of-type {
      margin-bottom: 4px;
    }
    height: 40px;
    button {
      width: 100%;
      height: 100%;

      border-radius: var(--Radius-100);
    }
    &.active {
      button {
        background-color: ${colors.blue.$300};
        color: white;
      }
    }
    :hover {
      background-color: ${colors.gray.$200};
    }
  `,
}

export default S
